import { helper as buildHelper } from "@ember/component/helper";
import Ember from "ember";

export function uppercaseFirst(value /* , options */) {
  let escaped = Ember.Handlebars.Utils.escapeExpression(value);
  return (escaped[0] || "").toUpperCase() + escaped.substr(1);
}

export default buildHelper(uppercaseFirst);
